// import CStorage from "./CStorage";
import axios from 'axios';

export default {
    fetchProgress() {
        // let defaulProgress = {
        //     completedLessons: [],
        //     completedCourses: [],
        //     currentLesson: {
        //         id: 1,
        //         currentTabIndex: 0,
        //         currentTestId: null,
        //         timerSeconds: 0
        //     },
        //     points: 0,
        // }
        // return CStorage.getItem('PR_PROGRESS', defaulProgress)

        return axios.get('/progress')
            .then(response => response.data);
    },

    fetchLessonProgress(lessonId) {
        return axios.get('/progress-lesson/' + lessonId)
            .then(response => response.data);
    },

    saveProgress(lessonId, tab, testId, timerSeconds, videoTime) {
        // let progress = this.fetchProgress()
        // progress.currentLesson.id = lessonId
        // progress.currentLesson.currentTabIndex = tab
        // progress.currentLesson.currentTestId = testId
        // progress.currentLesson.timerSeconds = timerSeconds
        // CStorage.setItem('PR_PROGRESS', progress)

        return axios.post('/progress', {
            id: lessonId,
            current_tab_index: tab,
            current_test_id: testId,
            timer_seconds: timerSeconds,
            video_time: Math.round(videoTime),
        });
    },

    completeLesson(lessonId, timerSeconds) {
        // let progress = this.fetchProgress()
        // if (!progress.completedLessons.includes(lessonId)) {
        //     progress.completedLessons.push(lessonId)
        //     CStorage.setItem('PR_PROGRESS', progress)
        // }

        return axios.post('/progress/lesson', {
            lesson_id: lessonId,
            timer_seconds: timerSeconds
        });
    },

    addPoints(points) {
        // let progress = this.fetchProgress()
        // progress.points = progress.points + points
        // CStorage.setItem('PR_PROGRESS', progress)
        return axios.put('/progress/points', { points });
    },

    fetchStatisticByCourse(courseId) {
        return axios.get(`/progress/${courseId}`)
            .then(response => response.data);
    }
}
